module.exports = __webpack_public_path__ + "img/selected2-min.0f0d3506.png";